"use client";

import styles from "./ForgotPasswordEmailInput.module.scss";

import {
  setFieldError,
  setFieldValue } from "@/stores";

import { useForm } from "@/hooks";
import { useTranslations } from "@/i18n";
import {
  Fieldset,
  Input,
} from "@vetty/ui";

/**
 * ForgotPasswordEmailInput Component
 *
 * Email input field for password reset form with validation and error handling.
 * Manages email field state and clears errors on user input.
 */
export const ForgotPasswordEmailInput = () => {
  const t = useTranslations("forgotPassword.form");

  // Get form errors from global state
  const { errors } = useForm();

  /**
   * Handles email input changes
   * Updates field value and clears any existing errors
   */
  const handleInputChange = (field: string, value: string) => {
    setFieldValue(field, value);
    setFieldError(field, "");
  };

  return (
    <Fieldset
      className={styles["comp"]}
      isError={errors.email}
      errorMessage={errors.email}
    >
      <Input
        id={"email"}
        label={t("email")}
        onChange={(v) => handleInputChange("email", v)}
      />
    </Fieldset>
  );
};
